<template>
  <div class="study-container">
    <div class="study-wrap main-width">
      <v-title title="学术研究" url="/views/study/sudi" />
      <div class="study-content">
        <div class="study-left">
          <div class="sudi-item" v-for="(item, index) in sudiList" :key="index">
            <Sudi :info="item" title="学术著作"></Sudi>
          </div>
          <div class="sudi-item" v-for="(item, index) in qikanList.slice(0, 2)" :key="index * 20 + 20">
            <Sudi :info="item" title="期刊论文"></Sudi>
          </div>
        </div>
        <!-- <div class="study-right">
          <h4 class="right-title">最新论文推荐</h4>
          <div class="qikan-list">
            <div class="qikan-item" v-for="(item, index) in qikanList" :key="index">
              <Qikan :info="item" v-if="index > 1"></Qikan>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import VTitle from "./components/title/index";
import Sudi from "./components/study/sudi";
import Qikan from "./components/study/qikan";
export default {
  data() {
    return {

    }
  },
  props: {
    sudiList: {
      type: Array,
      default: () => []
    },
    qikanList: {
      type: Array,
      default: () => []
    }
  },
  components: {
    VTitle, Sudi, Qikan
  },
  mounted() {

  },
  methods: {

  },
}
</script>

<style lang="less" scoped>
.study-container {
  padding: 20px 0;
  .study-content {
    display: flex;
    padding: 20px 0;
    .study-left {
      // width: 930px;
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .sudi-item {
        width: calc((100% - 90px) / 4);
        height: 360px;
        & + .sudi-item {
          margin-left: 30px;
        }
      }
    }
    .study-right {
      width: calc(100% - 930px - 20px);
      margin-left: 20px;
      .right-title {
        color: #212529;
        font-size: 16px;
        line-height: 22px;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .study-container {
    padding: 0;
    .study-content {
      padding: 14px 0;
      .study-left {
        gap: 14px;
        flex-wrap: wrap;
        .sudi-item {
          width: calc(50% - 7px);
          height: auto;
          aspect-ratio: 3/4;
          & + .sudi-item {
            margin-left: 0;
          }
        }
      }
      .study-right {
        display: none;
        width: calc(100% - 930px - 20px);
        margin-left: 20px;
        .right-title {
          color: #212529;
          font-size: 16px;
          line-height: 22px;
        }
      }
    }
  }
}
</style>